import React from 'react';
import { Image } from 'lucide-react';
import MediaPreview from './SharedMediaPreview';

interface ImagePreviewerProps {
    fileName: string;
}

const ImagePreviewer: React.FC<ImagePreviewerProps> = ({ fileName }) => {
    // If no fileName, show placeholder immediately
    if (!fileName) {
        return (
            <div className="fallback-content w-full h-full flex flex-col items-center justify-center gap-1 text-gray-500">
                <Image className="h-6 w-6" />
                <span className="text-xs">Image Placeholder</span>
            </div>
        );
    }

    return (
        <div className="w-full h-full" style={{ overflow: 'hidden' }}>
            <MediaPreview
                fileName={fileName}
                type="image"
                className="w-full h-full"
                style={{ objectFit: 'fill', width: '100%', height: '100%' }}
            />
        </div>
    );
};

export default ImagePreviewer;
